export const CURRENCY_SYMBOLS = {
  GBP: '£',
  EUR: '€',
  USD: '$',
  INR: '₹',
  AED: 'د.إ',
  CAD: 'C$',
  AUD: 'A$',
  SGD: 'S$',
};

export const getCurrencySymbol = () => {
  const code = localStorage.getItem('appCurrency') || 'EUR';
  return CURRENCY_SYMBOLS[code] || '€';
};
